/*
 * FileInput
 * 文件上传组件
 * created by zhaoqize
 * zhaoqize@meituan.com
 */
import RooFileInput from './FileInput';
export * from './interface';
export default RooFileInput;